import common_de from "./de/common.json";
import baking_de from "./de/baking.json";

import common_en from "./en/common.json";
import baking_en from "./en/baking.json";

import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
    en: {
        common: common_en,               // 'common' is our custom namespace
        baking: baking_en
    },
    de: {
        common: common_de,
        baking: baking_de
    },
}

i18next.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        interpolation: { escapeValue: false },  // React already does escaping
        resources,
        defaultNS: 'common',
        fallbackLng: 'en',

});

export default i18next
